import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class InfosasService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllInfosas(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.infosasUrl}/all`,
			'getAllInfosas'
		);
	}


	getInfosasById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.infosasUrl}/get/${id}`,
			'getInfosasById'
		);
	}

	updateInfosas(Infosas: Prestation): Observable<Prestation> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.infosasUrl}/update/${Infosas.id}`,
			'updateInfosas',
			Infosas
		);
	}

	addInfosas(Infosas: Prestation): Observable<Prestation> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.infosasUrl}/add`,
			'addInfosas',
			Infosas
		);
	}

	deleteInfosas(InfosasId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.infosasUrl}/delete/${InfosasId}`,
			`deleteInfosas`
		);
	}

}
